import React from 'react';
import { ArrowPathIcon } from '@heroicons/react/24/outline';

const RefreshButton = ({ 
  onClick, 
  disabled = false, 
  isRefreshing = false, 
  loading = false,
  text = 'Refresh',
  loadingText = 'Refreshing...',
  size = 'md',
  className = '',
  title = 'Refresh data'
}) => {
  const isDisabled = disabled || isRefreshing || loading;
  
  const sizeClasses = {
    sm: 'px-3 py-2 text-xs',
    md: 'px-4 py-2.5 text-sm',
    lg: 'px-6 py-3 text-sm'
  };
  
  const iconSizes = {
    sm: 'h-3 w-3',
    md: 'h-4 w-4',
    lg: 'h-5 w-5'
  };

  return (
    <button
      onClick={onClick}
      disabled={isDisabled}
      className={`
        group relative inline-flex items-center justify-center 
        font-semibold text-white 
        bg-gradient-to-r from-indigo-600 to-indigo-700 
        hover:from-indigo-700 hover:to-indigo-800 
        focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2
        rounded-lg shadow-lg hover:shadow-xl 
        transform transition-all duration-200 ease-in-out
        hover:scale-105 active:scale-95
        disabled:opacity-60 disabled:cursor-not-allowed disabled:transform-none
        ${isRefreshing ? 'animate-pulse' : ''}
        ${sizeClasses[size]}
        ${className}
      `}
      title={title}
    >
      <ArrowPathIcon 
        className={`
          ${iconSizes[size]} mr-2 transition-transform duration-300 
          ${isRefreshing ? 'animate-spin' : 'group-hover:rotate-180'}
        `} 
      />
      <span className="font-medium">
        {isRefreshing ? loadingText : text}
      </span>
    </button>
  );
};

export default RefreshButton;
